<template>
  <div class="left">
    <ul class="person-center">
      <li class="f18 font-MT text-333" v-for="(item, index) in navlist" :key="item.name">
        <router-link
                v-if="item.url"
                :to="item.url"
                class="text-333 flexible aItem-center"
                :class="{ active: oIndex == index, link: link }"
        >
            <img class="slider-icon" :src="$route.path  == item.url ? item.icon1: item.icon" />
            <span class="sidebar-name">{{ item.name }}
                <!-- <i v-if="noticeNum >0&&item.url == '/message'" class="notice-num"></i> -->
                </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    props: {
        // noticeNum: Number,
        isSmall: Boolean,
        oIndex: Number,
        link: Boolean,
        isSet: Boolean,
        isAuthor: Boolean,
        totalPage: Number,
        sAuthor: Boolean
    },
  data () {
    return{
      navlist: [
        { url: "/author", name: "作品管理",icon: require('@/assets/author/icon1-default.png'),icon1: require('@/assets/author/icon1-selected.png')},
        { url: "/author/income", name: "收益中心",icon: require('@/assets/author/icon2-default.png'),icon1: require('@/assets/author/icon2-selected.png')},
        { url: "/author/message", name: "我的消息",icon: require('@/assets/author/icon3-default.png'),icon1: require('@/assets/author/icon3-selected.png')},
        { url: "/author/info", name: "个人中心",icon: require('@/assets/author/icon4-default.png'),icon1: require('@/assets/author/icon4-selected.png') },
      ],
    }
  },
    //   computed: mapState({
    //     info: state => (state.user.img ? state.user.img : null)
    //   }),
    created(){
        // console.log('sidebar');
    },
    methods: {
    }
};
</script>

<style lang="scss" scoped>
  @import "@/styles/author.scss";
</style>
